import { colors } from "styles/colors";

/** Light-theme chrome tokens for the editor top navigation bar. */
export const editorTopNavChrome = {
  barHeightPx: 48,
  controlHeightPx: 28,
  controlInnerHeightPx: 24,
  segmentedPaddingPx: 2,
  barBackground: colors.WHITE,
  barBorder: colors.GREY_100,
  title: colors.GREY_700,
  titleHover: colors.GREY_900,
  mutedText: colors.GREY_500,
  icon: colors.GREY_500,
  iconHover: colors.GREY_700,
  statusIcon: colors.GREY_300,
  iconButtonHoverBg: colors.GREY_50,
  segmentedTrack: colors.GREY_100,
  segmentedActive: colors.WHITE,
  segmentedBorder: colors.GREY_100,
  previewBarBorder: colors.GREY_100,
  previewBarButtonActiveBg: colors.GREY_100,
  tabInactive: colors.GREY_500,
  tabActive: colors.GREY_900,
  tabHoverBg: colors.GREY_50,
  tabGroupRadiusPx: 6,
  tabRadiusPx: 6,
  fullscreenShadow: "0 1px 3px rgba(32, 36, 48, 0.08)",
  logoMarkSizePx: 28,
  logoMarkRadiusPx: 6,
  logoMarkBackground: colors.GREY_900,
  logoIconSizePx: 22,
} as const;
